import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { EventForm } from "./content-forms/EventForm";
import { NewsForm } from "./content-forms/NewsForm";
import { GalleryForm } from "./content-forms/GalleryForm";
import { PricelistForm } from "./content-forms/PricelistForm";
import { OfferForm } from "./content-forms/OfferForm";

// [create-title, edit-title] per dialog type
const TITLES = {
  event: ["Neuen Termin erstellen", "Termin bearbeiten"],
  news: ["Neue Nachricht erstellen", "Nachricht bearbeiten"],
  gallery: ["Neuen Galerieeintrag erstellen", "Galerieeintrag bearbeiten"],
  pricelist: ["Neuen Eintrag erstellen", "Eintrag bearbeiten"],
  offer: ["Neues Angebot erstellen", "Angebot bearbeiten"],
};

export function ContentDialog({ dialog, formData, setFormData, editingId, managedClubs, api, onSave, onClose }) {
  const f = (key, val) => setFormData(prev => ({ ...prev, [key]: val }));
  const [createTitle, editTitle] = TITLES[dialog] || ["", ""];
  const formProps = { formData, f, managedClubs, api };

  return (
    <Dialog open={!!dialog} onOpenChange={onClose}>
      <DialogContent className="bg-card border-white/10 max-w-md">
        <DialogHeader>
          <DialogTitle className="font-bold uppercase tracking-tight" style={{ fontFamily: 'Oswald' }}>
            {editingId ? editTitle : createTitle}
          </DialogTitle>
          <DialogDescription className="sr-only">Formular zum Erstellen oder Bearbeiten von Inhalten</DialogDescription>
        </DialogHeader>

        <div className="space-y-3 max-h-[60vh] overflow-y-auto">
          {dialog === "event" && <EventForm {...formProps} />}
          {dialog === "news" && <NewsForm {...formProps} />}
          {dialog === "gallery" && <GalleryForm {...formProps} />}
          {dialog === "pricelist" && <PricelistForm {...formProps} />}
          {dialog === "offer" && <OfferForm {...formProps} />}
        </div>

        <DialogFooter>
          <button onClick={onClose} className="px-4 py-2 text-sm text-muted-foreground hover:text-foreground">Abbrechen</button>
          <button onClick={onSave} data-testid="dialog-save-btn"
            className="px-4 py-2 bg-primary text-primary-foreground text-sm font-bold uppercase">
            {editingId ? "Aktualisieren" : "Speichern"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
